/*!
 * jQuery Slick Gallery v1
 *
 * Copyright (c) 2017 Haley Lohrenz
 * Released under the MIT license
 * Description: Turn any slickjs carousel/slider into a gallery
 */
(function( factory ) {
    if ( typeof define === "function" && define.amd ) {
        define( ["jquery"], factory );
    } else if (typeof module === "object" && module.exports) {
        module.exports = factory( require( "jquery" ) );
    } else {
        factory( jQuery );
    }
}(function( $ ) {
 
    var settings = {};
    var thumbnailSettings = {};
    var $container;
    var $_pagination;
    var _activePage = 1;
    var _totalThumbs;
    var _totalPages;
 
    var methods = {
        init: function( options ) {
            settings = $.extend({}, {
                thumbnailElement: '.slider-thumbs', // The DOM element/string that holds all the thumbnails
                slide: '.slide', // The class that holds each slide in the main (large image) gallery section
                thumbnailSlide: '.slide', // The class that holds each slide in the thumbnail section
                rows: 1, // How many rows to show on each page (leave it at 1 if there is no pagination or don't specify)
                slidesPerRow: 3, // How many slides to show in each row
                clickSlide: false, // Allow slider to move to the next slide on click (main slider),
                startingSlide: 0, // The slide to start on. This is great to specify when a modal dialog is opened based on the thumbnail they clicked on in the original slider
                paginationEnabled: true, // If you want pagination to be enabled on the thumbnails
                paginationLeftArrow: '<i class="fa fa-angle-left"></i>', // The markup for the left arrow on paging
                paginationRightArrow: '<i class="fa fa-angle-right"></i>', // The markup for the right arrow on paging
                paginationMidNumbers: 3, // How many numbers to show in the middle between the ... and the first and last page number
                infinite: false // If you want the slider to be infinite so they can keep clicking the arrows (a slick.js)
            }, options);
            
            thumbnailSettings = {
                initialSlide: 0,
                rows: settings.rows,
                slidesPerRow: settings.slidesPerRow,
                arrows: false,
                infinite: false
            };
            
            var currentlySwiping = false;
 
            $container = $(this);
            settings.thumbnailElement = (settings.thumbnailElement instanceof jQuery ? settings.thumbnailElement : $(settings.thumbnailElement));
            
            // On init, initiate on click events.
            if (settings.clickSlide) {
                $container.on('init', function(event, slick) {
                    // Enable on click for item to slide main slider over.
                    slick.$slider.on('click', settings.slide, function() {
                        slick.$slider.slick('slickNext');
                    });
                });
            }
            
            if (settings.paginationEnabled) {
                methods._setupPagination();
            }
            
            $container.slick({
                initialSlide: settings.startingSlide,
                arrows: false,
                fade: true
            });
            
            // Initiate slide thumbnails now.
            settings.thumbnailElement.slick(thumbnailSettings);
            
            $container.slick('setPosition', 0);
            settings.thumbnailElement.slick('setPosition', 0);
            
            // Bind on click events for grid mode (asNavFor)
            settings.thumbnailElement.on('click', settings.thumbnailSlide, function(e) {
                if (! currentlySwiping) {
                    e.stopPropagation();
                    var index = $(this).data('indx');
                    $container.slick('goTo', index);
                }
            });
            
            // Register flag on slider
            settings.thumbnailElement.on('beforeChange', function() {
                currentlySwiping = true;
            });
            settings.thumbnailElement.on('afterChange', function() {
                currentlySwiping = false;
            });
            
            if (settings.paginationEnabled) {
                // Let's see if the starting slide is on any other page.
                var thumbsPerSlide = settings.rows * settings.slidesPerRow;
                
                if (settings.startingSlide > thumbsPerSlide) {
                    // It's on a different page other than 1.
                    page = Math.ceil(settings.startingSlide / thumbsPerSlide);
                    
                    methods._goToPage(page);
                }
            }
        },
        
        _setupPagination: function() {
            // Update class on thumbnail slider if more than one row
            if (settings.rows > 1) {
                settings.thumbnailElement.addClass('multi-row');
            }
            
            // Inject pagination
            _totalThumbs = settings.thumbnailElement.find(settings.thumbnailSlide).length;
            _totalPages = Math.ceil(_totalThumbs / (settings.rows * settings.slidesPerRow));
            
            $_pagination = $('<nav id="thumbnail-pagination" class="thumbnail-pagination" aria-label="Thumbnail Pagination" />');
            var $ul = $('<ul class="pagination"></ul>');
            $ul.append($('<li class="page-item page-arrow prev">').append($('<a class="page-link" href="#">' + settings.paginationLeftArrow + '</a></li>')));
            
            for (var i = 1; i <= _totalPages; i++) {
                if (_activePage === i) {
                    $ul.append($('<li class="page-item active" data-index="' + i + '">').append($('<a class="page-link" href="#">' + i + '</a>')));
                } else {
                    $ul.append($('<li class="page-item" data-index="' + i + '">').append($('<a class="page-link" href="#">' + i + '</a>')));
                }
                
                if (i === 1) {
                    $ul.append($('<li class="page-item disabled dots first">').append($('<span class="page-link">...</span>')));
                }
                if (i + 1 === _totalPages) {
                    $ul.append($('<li class="page-item disabled dots last">').append($('<span class="page-link">...</span>')));
                }
            }
            
            $ul.append($('<li class="page-item page-arrow next">').append($('<a class="page-link" href="#">' + settings.paginationRightArrow + '</a></li>')));
            $_pagination.append($ul);
            
            // Check if any arrows should be disabled
            if (_activePage === 1) {
                methods._disableLeftArrow();
            } else if (_activePage === _totalPages) {
                methods._disableRightArrow();
            }
            
            methods._togglePaginationLinks();
            
            // Now append at bottom of thumbnails
            settings.thumbnailElement.parent().append($_pagination);
            
            // Init on click events for pagination.
            $_pagination.on('click', '.page-arrow.prev:not(.disabled)', function(e) {
                e.preventDefault();
                // Update active page.
                var nextPage = _activePage == 1 ? 1 : _activePage - 1;
                
                methods._goToPage(nextPage);
            });
            
            $_pagination.on('click', '.page-arrow.next:not(.disabled)', function(e) {
                e.preventDefault();
                // Update active page.
                var nextPage = _activePage == _totalPages ? _totalPages : _activePage + 1;
                
                methods._goToPage(nextPage);
            });
            
            $_pagination.on('click', '.page-item:not(.page-arrow)', function(e) {
                e.preventDefault();
                var $page = $(this);
                
                // If active page or it's an arrow, ignore
                if ($page.hasClass('active') || $page.hasClass('.dots')) {
                    return;
                }
                
                // They clicked on a page that isn't active so let's do some logic.
                var nextPage = $page.data('index');
                
                // If they are going one over.
                if (_activePage - 1 === nextPage) {
                    $_pagination.find('.page-arrow.prev').trigger('click');
                } else if (_activePage + 1 === nextPage) {
                    $_pagination.find('.page-arrow.next').trigger('click');
                } else {
                    methods._goToPage(nextPage);
                }
            });
        },
        
        _goToPage: function(page, callback) {
            settings.thumbnailElement.slick('slickGoTo', page - 1); // Slickjs indexing starts at 0
            methods._updateActivePage(page);
            
            _activePage = page;
            
            // Update pagination information.
            methods._togglePaginationLinks();
            
            // See if we need to disable any arrows.
            if (_activePage === 1) {
                methods._disableLeftArrow();
            } else if (_activePage === _totalPages) {
                methods._disableRightArrow();
            } else {
                // Enable all arrows.
                methods._enableArrows();
            }
        },
        
        _enableArrows: function() {
            $_pagination.find('.page-arrow.disabled').removeClass('disabled');
        },
        
        _disableRightArrow: function() {
            $_pagination.find('.page-arrow.prev.disabled').removeClass('disabled');
            $_pagination.find('.page-arrow.next').addClass('disabled');
        },
        
        _disableLeftArrow: function() {
            $_pagination.find('.page-arrow.next.disabled').removeClass('disabled');
            $_pagination.find('.page-arrow.prev').addClass('disabled');
        },
        
        _updateActivePage: function(index) {
            $_pagination.find('.page-item.active').removeClass('active');
            $_pagination.find('.page-item:not(.page-arrow)[data-index="' + index + '"]').addClass('active');
        },
        
        _destroyPagination: function() {
            $_pagination.remove();
            _activePage = 1; // reset
        },
        
        _togglePaginationLinks: function() {
            if (_totalPages <= settings.paginationMidNumbers) {
                $_pagination.find('.page-item.dots').addClass('d-none');
                return;
            }
            
            // Hide everything and let's show the stuff we need to show.
            $_pagination.find('.page-item').addClass('d-none');
            
            // There are more than 3 pages so here is where it gets fun.
            if (_activePage <= (_totalPages - settings.paginationMidNumbers)) {
                // Show the right dots
                $_pagination.find('.page-item.dots.last').removeClass('d-none');
            } else if (_activePage > settings.paginationMidNumbers) {
                // Show the left dots
                $_pagination.find('.page-item.dots.first').removeClass('d-none');
            }
            
            // Toggle arrows
            if (_activePage > 1) {
                $_pagination.find('.page-arrow.prev').removeClass('d-none');
            }
            if (_activePage < _totalPages) {
                $_pagination.find('.page-arrow.next').removeClass('d-none');
            }
            
            // Show first and last pages no matter what
            $_pagination.find('.page-item[data-index="' + _totalPages + '"]').removeClass('d-none');
            $_pagination.find('.page-item[data-index="1"]').removeClass('d-none');
            
            // If on first page, only show the number of numbers - 1 to the right of it.
            if (_activePage === 1) {
                for (var i = 2; i <= settings.paginationMidNumbers; i++) {
                    $_pagination.find('.page-item[data-index="' + i + '"]').removeClass('d-none');
                }
                return;
            }
            
            // If on last page, only show the number of numbers - 1 to the left of it.
            if (_activePage === _totalPages) {
                var starter = _totalPages - (_totalPages - settings.paginationMidNumbers);
                for (var i = starter; i < _totalPages; i++) {
                    $_pagination.find('.page-item[data-index="' + i + '"]').removeClass('d-none');
                }
                return;
            }
            
            // They are on a page that is not the first or last page so let's grab the range around that link.
            var linksOnSide = Math.floor(settings.paginationMidNumbers / 2);
            
            for (var i = (_activePage - linksOnSide); i <= (_activePage + linksOnSide); i++) {
                $_pagination.find('.page-item[data-index="' + i + '"]').removeClass('d-none');
            }
            
            return;
        },
        
        destroy: function() {
            $container.slick('unslick');
            settings.thumbnailElement.slick('unslick');
            
            // If pagination is enabled, remove it.
            if (settings.paginationEnabled) {
                methods._destroyPagination();
            }
        }
    };
 
    $.fn.slickGallery = function( methodOrOptions ) {
        if ( methods[methodOrOptions] ) {
            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
            // Default to "init"
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.slickGallery' );
        }
    };
 
}));
